import { create } from 'zustand';

import { client as api2Client } from 'util/api2Client';
import { locationQuery } from 'graphql/location';

const initialState = {
  locations: [],
  loading: false,
};

const useLocationStore = create((set, get) => ({
  ...initialState,
  searchLocations: async (query) => {
    const options = {
      variables: {
        query,
      },
      query: locationQuery,
      fetchPolicy: 'no-cache',
      errorPolicy: global.IS_DEV ? 'all' : 'none',
    };

    try {
      set({ loading: true });
      const result = await api2Client.query(options);

      // Filter to ensure unique city + stateCode combinations
      const uniqueCombinations = new Set();
      const uniqueLocations = result.data.locations.filter((location) => {
        const combination = `${location.city}|${location.stateCode}`;
        if (uniqueCombinations.has(combination)) {
          return false; // Duplicate found, exclude from results
        } else {
          uniqueCombinations.add(combination);
          return true; // Unique combination, include in results
        }
      });

      set({
        locations: uniqueLocations,
      });
      return uniqueLocations;
    } catch (err) {
      console.error('searchLocations', err);
      return [];
    } finally {
      set({ loading: false });
    }
  },
  reset: () => {
    set(initialState);
  },
}));

export default useLocationStore;
